export default __webpack_public_path__ + "static/media/right.708b3b48.jpg";